import { TimeWindow } from '@ui/interfaces'
import dayjs from '@ui/lib/utils/dayjs'
import { v4 as uuidv4 } from 'uuid'

export const uuid = (): string => uuidv4()

export const sizeInBytes = (str: string): number => {
  return new Blob([str]).size
}

export const getInAbsoluteTime = (timewindow: TimeWindow) => {
  const [time, unit] = timewindow.relative
  const endTime = dayjs().endOf('minute').toDate()

  const startTime = dayjs()
    .startOf('minute')
    .subtract(time, unit as dayjs.ManipulateType)
    .toDate()

  return { startTime, endTime }
}

const emojis = [
  '🍇 Grapes',
  '🍈 Melon',
  '🍉 Watermelon',
  '🍊 Tangerine',
  '🍋 Lemon',
  '🍌 Banana',
  '🍍 Pineapple',
  '🥭 Mango',
  '🍎 Red Apple',
  '🍏 Green Apple',
  '🍐 Pear',
  '🍑 Peach',
  '🍒 Cherries',
  '🍓 Strawberry',
  '🫐 Blueberries',
  '🥝 Kiwi Fruit',
  '🍅 Tomato',
  '🫒 Olive',
  '🥥 Coconut',
  '🥑 Avocado',
  '🍆 Eggplant',
  '🥔 Potato',
  '🥕 Carrot',
  '🌽 Ear of Corn',
  '🌶️ Hot Pepper',
  '🫑 Bell Pepper',
  '🥒 Cucumber',
  '🥬 Leafy Green',
  '🥦 Broccoli',
  '🧄 Garlic',
  '🧅 Onion',
  '🍄 Mushroom',
  '🥜 Peanuts',
  '🌰 Chestnut',
  '🍞 Bread',
  '🥐 Croissant',
  '🥖 Baguette Bread',
  '🫓 Flatbread',
  '🥨 Pretzel',
  '🥯 Bagel',
  '🥞 Pancakes',
  '🧇 Waffle',
  '🧀 Cheese Wedge',
  '🍖 Meat on Bone',
  '🍗 Poultry Leg',
  '🥩 Cut of Meat',
  '🥓 Bacon',
  '🍔 Hamburger',
  '🍟 French Fries',
  '🍕 Pizza',
  '🌭 Hot Dog',
  '🥪 Sandwich',
  '🌮 Taco',
  '🌯 Burrito',
  '🫔 Tamale',
  '🥙 Stuffed Flatbread',
  '🧆 Falafel',
  '🥚 Egg',
  '🍳 Cooking',
  '🥘 Shallow Pan of Food',
  '🍲 Pot of Food',
  '🫕 Fondue',
  '🥣 Bowl with Spoon',
  '🥗 Green Salad',
  '🍿 Popcorn',
  '🧈 Butter',
  '🧂 Salt',
  '🥫 Canned Food',
  '🍱 Bento Box',
  '🍘 Rice Cracker',
  '🍙 Rice Ball',
  '🍚 Cooked Rice',
  '🍛 Curry Rice',
  '🍜 Steaming Bowl',
  '🍝 Spaghetti',
  '🍠 Roasted Sweet Potato',
  '🍢 Oden',
  '🍣 Sushi',
  '🍤 Fried Shrimp',
  '🍥 Fish Cake with Swirl',
  '🥮 Moon Cake',
  '🍡 Dango',
  '🥟 Dumpling',
  '🥠 Fortune Cookie',
  '🥡 Takeout Box',
  '🦪 Oyster',
  '🍦 Soft Ice Cream',
  '🍧 Shaved Ice',
  '🍨 Ice Cream',
  '🍩 Doughnut',
  '🍪 Cookie',
  '🎂 Birthday Cake',
  '🍰 Shortcake',
  '🧁 Cupcake',
  '🥧 Pie',
  '🍫 Chocolate Bar',
  '🍬 Candy',
  '🍭 Lollipop',
  '🍮 Custard',
  '🍯 Honey Pot',
  '🍼 Baby Bottle',
  '🥛 Glass of Milk',
  '☕ Hot Beverage',
  '🫖 Teapot',
  '🍵 Teacup Without Handle',
  '🍶 Sake',
  '🍾 Bottle with Popping Cork',
  '🍷 Wine Glass',
  '🍸 Cocktail Glass',
  '🍹 Tropical Drink',
  '🍺 Beer Mug',
  '🍻 Clinking Beer Mugs',
  '🥂 Clinking Glasses',
  '🥃 Tumbler Glass',
  '🥤 Cup with Straw',
  '🧋 Bubble Tea',
  '🧃 Beverage Box',
  '🧉 Mate',
  '🧊 Ice',
  '🥢 Chopsticks',
  '🍽️ Fork and Knife with Plate',
  '🍴 Fork and Knife',
  '🥄 Spoon',
]

export const generateUniqueColor = (index: number) => {
  const colors = [
    '#FF6633',
    '#FFB399',
    '#FF33FF',
    '#FFFF99',
    '#00B3E6',
    '#E6B333',
    '#3366E6',
    '#999966',
    '#99FF99',
    '#B34D4D',
    '#80B300',
    '#809900',
    '#E6B3B3',
    '#6680B3',
    '#66991A',
    '#FF99E6',
    '#CCFF1A',
    '#FF1A66',
    '#E6331A',
    '#33FFCC',
    '#66994D',
    '#B366CC',
    '#4D8000',
    '#B33300',
    '#CC80CC',
    '#66664D',
    '#991AFF',
    '#E666FF',
    '#4DB3FF',
    '#1AB399',
    '#E666B3',
    '#33991A',
    '#CC9999',
    '#B3B31A',
    '#00E680',
    '#4D8066',
    '#809980',
    '#E6FF80',
    '#1AFF33',
    '#999933',
    '#FF3380',
    '#CCCC00',
    '#66E64D',
    '#4D80CC',
    '#9900B3',
    '#E64D66',
    '#4DB380',
    '#FF4D4D',
    '#99E6E6',
    '#6666FF',
  ]

  return colors[index % colors.length]
}

export const profileColors = [
  'bg-[#FDE2E4]',
  'bg-[#FAD2E1]',
  'bg-[#E2ECE9]',
  'bg-[#F9F7C8]',
  'bg-[#D5CFE1]',
  'bg-[#F8EDE3]',
  'bg-[#E4F1F6]',
  'bg-[#FEECE2]',
  'bg-[#E3E8F0]',
  'bg-[#F5E6E8]',
]

export const getInitials = (name: string): string => {
  const names = name.split(' ')
  return names
    .map((n) => n.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('')
}

export const randomLabel = (): string => {
  return emojis[~~(Math.random() * emojis.length)]
}

// https://stackoverflow.com/questions/4498866/actual-numbers-to-the-human-readable-values
export const readableBytes = (bytes: number) => {
  if (bytes === 0) return '0 bytes'

  const s = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB']
  const e = Math.floor(Math.log(bytes) / Math.log(1024))
  return (bytes / Math.pow(1024, e)).toFixed(2) + ' ' + s[e]
}

// https://stackoverflow.com/questions/2901102/how-to-format-a-number-with-commas-as-thousands-separators
export const readableNumber = (x: number) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const truncate = (str: string, width: number) => {
  const regex = new RegExp(`^(.{${width}}).{2,}`)
  return str.replace(regex, '$1…')
}

export const convertBytesToText = (bytes: number | null, addUnitSuffix: boolean = true) => {
  const units = ['bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

  let l = 0,
    n = bytes || 0

  while (n >= 1024 && ++l) {
    n = n / 1024
  }
  const result = n.toFixed(n < 10 && l > 0 ? 1 : 0)
  if (addUnitSuffix) {
    return result + ' ' + units[l]
  }
  return result
}

export const isObject = (obj: unknown): obj is Record<string, never> => {
  return obj !== null && typeof obj === 'object'
}

export const deepEqual = (obj1: unknown, obj2: unknown): boolean => {
  if (obj1 === obj2) {
    return true
  }

  if (!isObject(obj1) || !isObject(obj2)) {
    return false
  }

  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)

  if (keys1.length !== keys2.length) {
    return false
  }

  for (const key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false
    }
  }

  return true
}

export const compareArraysOfObjects = <T extends Record<string, unknown>>(arr1: T[], arr2: T[]): boolean => {
  if (arr1.length !== arr2.length) {
    return false
  }

  for (const obj1 of arr1) {
    if (!arr2.some((obj2) => deepEqual(obj1, obj2))) {
      return false
    }
  }

  return true
}

export const compareSets = <T>(a: Set<T>, b: Set<T>): boolean => {
  if (a.size !== b.size) return false

  for (const element of a) {
    if (!b.has(element)) return false
  }

  return true
}

export const removeTypename = <T extends { __typename?: string }>(obj: T): Omit<T, '__typename'> => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { __typename, ...rest } = obj
  return rest
}
